/* eslint-disable default-param-last */
import { HYDRATE } from 'next-redux-wrapper';
import merge from 'deepmerge';

export const types = {
  GET_LOGIN_TYPE: 'CLIENT/GET_LOGIN_TYPE',
  SET_LOGIN_TYPE: 'CLIENT/SET_LOGIN_TYPE',
  SET_STATUS: 'CLIENT/SET_STATUS',
  SET_CLIENT_MODULES: 'CLIENT/SET_CLIENT_MODULES',
  SET_CLIENT_INFO: 'CLIENT/SET_CLIENT_INFO',
  SET_R2R_TYPE: 'CLIENT/SET_R2R_TYPE',
  GET_MY_DATA: 'CLIENT/GET_MY_DATA',
  SET_MY_DATA: 'CLIENT/SET_MY_DATA',
  GET_MY_R2R: 'CLIENT/GET_MY_R2R',
  SET_MY_R2R: 'CLIENT/SET_MY_R2R',
  GET_RETENTION: 'CLIENT/GET_RETENTION',
  SET_RETENTION: 'CLIENT/SET_RETENTION',
  /* nextjs */
  HYDRATE: 'MAIN/HYDRATE',
};

export const actions = {
  getLoginType: (data = {
    document: null,
  }) => ({ type: types.GET_LOGIN_TYPE, ...data }),
  setLoginType: (data) => ({ type: types.SET_LOGIN_TYPE, loginType: data }),
  setStatus: (data) => ({ type: types.SET_STATUS, status: data }),
  setR2rType: (data) => ({ type: types.SET_R2R_TYPE, r2rType: data }),
  setClientModules: (data) => ({
    type: types.SET_CLIENT_MODULES,
    modulos: data,
  }),
  setClientInfo: (data) => ({
    type: types.SET_CLIENT_INFO,
    info: data,
  }),
  getMyData: (data) => ({ type: types.GET_MY_DATA, data }),
  setMyData: (data) => ({ type: types.SET_MY_DATA, misDatos: data }),
  getMyR2R: (data) => (
    {
      type: types.GET_MY_R2R,
      productOfferingConvergente: data,
    }),
  setMyR2R: (data) => ({ type: types.SET_MY_R2R, myR2R: data }),
  getRetention: (data) => ({
    type: types.GET_RETENTION,
    retentionModules: data,
  }),
  setRetention: (data) => ({ type: types.SET_RETENTION, retention: data }),
};

const initialState = {
  loginType: null,
  status: null,
  modulos: null,
};

function reducer(state = { ...initialState }, action) {
  switch (action.type) {
    case HYDRATE: {
      const { client } = action.payload;
      /* necesito preservar lo que viene del sever excepto los filtros */
      const nextState = merge(state, client);
      return nextState;
    }
    case types.SET_LOGIN_TYPE: {
      const { loginType } = action;
      return {
        ...state,
        loginType,
      }
    }
    case types.SET_STATUS: {
      const { status } = action;
      return {
        ...state,
        status,
      }
    }
    case types.SET_CLIENT_MODULES: {
      const { modulos } = action;
      return {
        ...state,
        modulos,
      };
    }
    case types.SET_CLIENT_INFO: {
      const { info } = action;
      return {
        ...state,
        ...info,
      };
    }
    case types.SET_R2R_TYPE: {
      const { r2rType } = action;
      return {
        ...state,
        r2rType,
      };
    }
    case types.SET_MY_DATA: {
      const { misDatos } = action;
      return {
        ...state,
        misDatos,
      };
    }
    case types.SET_MY_R2R: {
      const { myR2R } = action;
      return {
        ...state,
        r2r: myR2R,
      };
    }
    case types.SET_RETENTION: {
      const { retention } = action;
      return {
        ...state,
        retention,
      };
    }
    default:
      return state;
  }
}

export default reducer;
